export default __webpack_public_path__ + "static/media/key.f38bd0ad.svg";